module.exports = __webpack_public_path__ + "img/courses.33715854.svg";